<script setup lang="ts">
import { type PartnerType } from '@/features/partners';

const props = defineProps<{
  partnerType?: PartnerType;
}>();

const { staticUrl } = useRuntimeConfig().public;
const text = computed(() => {
  if (!props.partnerType) return 'Пока что нет услуг в корзине';
  const ofWho =
    props.partnerType === 'master' ? 'этого мастера' : 'этой компании';
  return `Пока что вы не выбрали никаких услуг ${ofWho}`;
});
</script>

<template>
  <div class="no-services-in-cart">
    <NuxtImg
      class="no-services-in-cart__image"
      format="webp"
      :src="`${staticUrl}/landing/forwhom2.png`"
    />
    {{ text }}
  </div>
</template>

<style scoped lang="scss">
.no-services-in-cart {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  text-align: center;

  &__image {
    width: 50%;
    height: auto;
  }
}
</style>
